module.exports = __webpack_public_path__ + "img/wenshang1.3319db46.png";